// BulkUsersNominationRemoval
import React, { useEffect, useState, useMemo, useRef } from 'react'
import Navbar from '../shared/Navbar';
import Sidebar from '../shared/Sidebar';
import SettingsPanel from '../shared/SettingsPanel';
import Footer from '../shared/Footer';
import { Styles } from "../../components/styles/nomination";
import { MultiSelect } from "react-multi-select-component";
import { FaSearch, FaRedo, FaArrowRight, FaSignOutAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Modal from '../usersNomination/Modal';
import DataTable from "react-data-table-component";
import FilterDataTable from "../../pages/instructor/FilterDataTable";
import StickyMenu from '../../components/common/StickyMenu'
import { Form, InputGroup, Row, Col, Button, Tooltip, Alert, Container } from 'react-bootstrap';
import service from '../../services/service';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Chart from 'chart.js';

const BulkUsersNominationRemoval = () => {
    const chartRef = useRef(null);
    let userType = "80f0892f69c34af2621f79db46ebcb7a" //md5("NONCDAC") = 698ee757148d901016c3df7880180feb

    const defaultNominationState = {
        courseName: "",
        courseId: 0,
        showModal: false,
        tableData: [],
        filterText_: "",
        resetPaginationToggle_: false,
        validateCourseName: false,
        action: {},
        nominationStatus: "",
        showTable: false,
        options: []

    }
    const [getNominationData, setNominationData] = useState(defaultNominationState)
    //Api call to setOptions
    useEffect(() => {
        //load course data
        loadCoursesList();
    }, []);
    const loadCoursesList = () => {
        service.getPublishCourses()
            .then(res => {
                if (res.data.length !== 0) {
                    const options = res.data.map((course) => {
                        const singleCourse = {
                            id: course.courseId,
                            label: course.courseName,
                            name: course.courseName
                        }

                        return singleCourse;
                    })
                    setNominationData((prevState) => {
                        return {
                            ...prevState,
                            options: options,

                        }
                    })
                }

            }).catch((err) => {
                toast.error("Server error, Unable to fetch courses!")
            })


    }
    useEffect(() => {

    }, [getNominationData])


    // const options = [
    //     { id: "85", label: 'java', name: 'java' },
    //     { id: "89", label: 'python', name: 'Python' },
    //     { id: "70", label: '.net', name: '.Net technology' },
    //     // Add more options as needed
    // ];

    //Data table
    // Table content Filter and Search /
    const [resetPaginationToggle, setResetPaginationToggle] =
        React.useState(false);
    const filteredItems = getNominationData.tableData?.filter(
        (item) =>
            JSON.stringify(item).toLowerCase().indexOf(getNominationData.filterText_.toLowerCase()) !==
            -1
    );
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (getNominationData.filterText_) {
                setResetPaginationToggle(!resetPaginationToggle);

                setNominationData((prevState) => {
                    return {
                        ...prevState,
                        resetPaginationToggle_: !getNominationData.resetPaginationToggle_,
                        filterText_: ""
                    }
                });
            }
        };

        return (
            <FilterDataTable
                onFilter={(e) => { setNominationData((prevState) => { return { ...prevState, filterText_: e.target.value } }) }}
                onClear={handleClear}
                filterText={getNominationData.filterText_}
            />
        );
    }, [getNominationData.filterText_, resetPaginationToggle]);
    const customStyles = {

        title: {
            style: {
                fontColor: "red",
                fontWeight: "900",
            },
        },
        headCells: {
            style: {
                fontSize: "17px",
                fontWeight: "500",
                paddingLeft: "0 8px",
                marginLeft: "10px",
            },
        },
        cells: {
            style: {
                fontSize: "15px",
                paddingLeft: '0 8px',
                marginLeft: '10px',
                cursor: "pointer"
            },
        },
    };
    const columns = [
       
        {
            name: "User Name",
            selector: (row) => `${row?.userFullname}`,
            sortable: true,
            wrap: true,
        },
        {
            name: "Email Id",
            selector: (row) => row?.userEmail,
            sortable: true,
        },
        // {
        //     name: "Center",
        //     selector: (row) => row?.userCentre,
        //     wrap: true,
        //     sortable: true,
        // },
        {
            name: "Contact",
            selector: (row) => row?.mobile,
            wrap: true,
            
        },
        
        {
            name: "Status",
            selector: (row) => (
                <div>
                    {
                        getNominationData.action[row.userId]?.selectForRemove ?
                            <span className='text-info text-uppercase font-weight-bold'>Selected</span>
                            : <span className='text-success text-uppercase font-weight-bold'>Nominated</span>
                    }
                </div>
            )

        },
        {
            name: "Action",
            wrap: true,
            cell: (row) => (
                <div>
                    {
                        getNominationData.action[row.userId]?.selectForRemove &&
                        <span className='text-info text-uppercase font-weight-bold'><i class="fa fa-check" aria-hidden="true" style={{ fontSize: "25px" }}></i></span>
                    }
                </div>
            )
        },
    ];
    /******************** Handlers section starts here ********************************************* */
    const handleSelectChange = (event) => {
       
        setNominationData((prevState) => {
            return {
                ...prevState,
                courseName: event.target.value,
                courseId: event.target.selectedOptions[0].id
            }
        })
        if (event.target.value !== "SelectCourse") {
            //valid
          
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    validateCourseName: false
                }
            })
        }
        else {
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    validateCourseName: true
                }
            })

        }



    };
    const handlerSearch = () => {
        //console.log(getNominationData.courseName);
        if (getNominationData.courseName !== "SelectCourse" && getNominationData.courseName !== '') {
            //valid
            
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    showModal: true,
                    tableData: []
                }
            })
            setTimeout(async() => {
                //fetch the data of all nominated users
               await service.removeNomineeSearch(getNominationData.courseId,userType)
                    .then(res => {
                        
                        if (res.data.length !== 0) {
                            setNominationData((prevState) => {
                                return {
                                    ...prevState,
                                    showTable: true,
                                    tableData: res.data
                                }
                            })
                        }
                        else {
                            setNominationData((prevState) => {
                                return {
                                    ...prevState,
                                    showTable: false,
                                }
                            })
                            toast.info(getNominationData.courseName + " Course doesn't have any nominted users");
                        }

                    }).catch((err) => {
                        toast.error("Server error");
                    })
                setNominationData((prevState) => {
                    return {
                        ...prevState,
                        showModal: false
                    }
                })

            }, [2000])
        }
        else {
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    validateCourseName: true
                }
            })

        }







    }

    const handlerRemoveNominees = () => {
        // alert("handlerNominted")
        if (Object.keys(getNominationData.action).length !== 0) { //need to change !==
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    showModal: true,

                }
            })
            setTimeout(() => {
                //console.log("keys", Object.keys(getNominationData.action));

                const userIds = Object.keys(getNominationData.action);
                
                service.removeNominees(getNominationData.courseId, userIds) //need to change 
                    .then((res) => {
                        //console.log("res.data.length", res.data === {}, res.data?.rejectedRemovedUserIds.length);
                        if (res.data != {}) {
                            if (res.data?.message !== "" && res.data?.successfulRemovedUserIds.length !== 0) {
                                toast.success(res.data.successfulRemovedUserIds.length + " Users removed successfully!")
                            }
                            if (res.data?.message !== "" && res.data?.rejectedRemovedUserIds.length !== 0) {
                                toast.warning(res.data?.rejectedRemovedUserIds.length + " Users not found!")
                            }

                        }

                        const courseList = getNominationData.options;
                        setNominationData(defaultNominationState);
                        setNominationData((prevState) => {
                            return {
                                ...prevState,
                                options: courseList
                            }
                        })
                    })
                    .catch((err) => {
                        toast.error("Server Error");
                    })
                // setNominationData((prevState) => {
                //     return {
                //         ...prevState,
                //         showModal: false,

                //     }
                // })
            }, [2000])


            // toast.success(Object.keys(getNominationData.action).length + " Users nominated for Course " + getNominationData.courseName + " Removed successfully!");
        }
        else {
            toast.warning("Select atleast one user for removal !");
        }


    }
    const handlerRowClick = (row) => {
        //console.log("con clinkc row ", row)
        if (Object.keys(getNominationData.action).includes(row.userId)) {
            const updateAction = { ...getNominationData.action }
            delete updateAction[row.userId]
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    action: updateAction
                }
            })
        } else {
            const singleUser = {
                selectForRemove: true
            }
            setNominationData((prevState) => {
                return {
                    ...prevState,
                    action: {
                        ...prevState.action,
                        [row.userId]: singleUser
                    }
                }
            })
        }

    }/********************Handlers section ends here ********************************************* */


    return (
        <Styles>

            <div className="container-scroller">
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                {
                    getNominationData.showModal &&
                    <div className='modal-loader'>
                        <Modal showModal={getNominationData.showModal} />
                    </div>

                }

                <Navbar />
                  {/* <StickyMenu /> */}

                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">

                            <div>
                                <div className="page-header">
                                    <h3 className="page-title">
                                        Remove Users From Course
                                    </h3>
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><a href="!#" onClick={event => event.preventDefault()}>Users Nomination</a></li>
                                            <li className="breadcrumb-item active" aria-current="page">Remove Nominations</li>
                                        </ol>
                                    </nav>
                                </div>

                            </div>
                            <div className=''>
                                {/* search section */}
                                <Row className='d-flex flex-sm-row w-100 bg-light px-4 py-4 ' sm={12}>
                                    {/* <Col className='p-2 ' lg={6}>
                                        <Form.Group className=' p-0' as={Col} controlId="formGridState">
                                            <Form.Select name='courseNames' className='w-100 p-2' defaultValue="Select course" handlerUserNameChange={(event) => { handlerUserNameChange(event); }}>
                                                <option>Select course</option>
                                                <option>...</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col> */}
                                    <Col className='px-0 py-1' sm={10}>
                                        {/* {`custom-multiselect w-100 px-2  ${getNominationData.validateCourseName ? "border border-danger " : ""}` */}
                                        <select className={`custom-single-select w-100 px-2 border bg-white rounded ${getNominationData.validateCourseName ? "border-danger" : ""
                                            }`} aria-label="Default select example" placeholder='Select course' style={{ paddingBlock: "10px", outline: "none" }} onChange={(e) => { handleSelectChange(e); }} value={getNominationData.courseName}>

                                            <option id='0' name="selectCourse" value="SelectCourse" className='text-muted' selected>Select course...</option>
                                            {
                                                getNominationData.options.map((singleCourse) => {
                                                    return (<option id={parseInt(singleCourse.id)} name={singleCourse.name}>{singleCourse.name}</option>)
                                                })
                                            }
                                        </select>
                                        {getNominationData.validateCourseName && <span className='text-danger'>Select the course</span>}
                                    </Col>
                                    <Col className='px-1 pt-2' sm={2}>
                                        <InputGroup className=" p-0 m-0 ">
                                            <Button className='' variant="success" id="search" onClick={handlerSearch}>

                                                <i className="fa fa-search fa-sm" aria-hidden="true"> <small className='d-none d-xl-inline'>Search</small></i>

                                            </Button >
                                        </InputGroup>

                                    </Col>

                                </Row>
                                <Row className=" w-100 p-4  bg-light py-4 grid-margin stretch-card" lg={12}>
                                    <div className="card">
                                        <div className="card-body">
                                            {
                                                getNominationData.showTable ?
                                                    <>
                                                        {
                                                            Object.keys(getNominationData.action).length !== 0 &&
                                                            <div class="alert alert-info" role="alert">
                                                                <strong>{Object.keys(getNominationData.action).length}</strong> users selected for Removal
                                                            </div>


                                                        }
                                                        {
                                                            Object.keys(getNominationData.action).length === 0 && getNominationData.tableData.length !== 0 &&
                                                            <div class="alert alert-warning" role="alert">
                                                                Click on a Row to Select User!
                                                            </div>
                                                        }
                                                        <DataTable
                                                            columns={columns}
                                                            data={filteredItems}
                                                            defaultSortField="Name"
                                                            defaultSortAsc={true}
                                                            striped
                                                            pagination
                                                            highlightOnHover
                                                            customStyles={customStyles}
                                                            subHeader
                                                            subHeaderComponent={subHeaderComponent}
                                                            onRowClicked={handlerRowClick}
                                                        />
                                                        <Col className='p-2' lg={6}>
                                                            <Button onClick={handlerRemoveNominees} className='' variant='success' id="nominate" name='nominated' >
                                                                Remove Nominees
                                                            </Button>
                                                        </Col>
                                                    </>

                                                    :
                                                    <div class="alert alert-info" role="alert">
                                                        No records to display, click on search
                                                    </div>

                                            }
                                        </div>
                                    </div>
                                </Row>
                            </div>

                            <SettingsPanel />
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

        </Styles>
    )
}

export default BulkUsersNominationRemoval
